import React, { memo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { RootState } from '../../redux/store'
import { MeasurementDevicesTableWidget } from '../../../common/features/measurement-device/measurement-devices-table-widget'
import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { MeasurementDeviceSearchListForm } from '../../../common/features/measurement-device/measurement-device-search-list-form'
import {
    MeasurementDevicesGetFilteredApiArg,
    useMeasurementDevicesGetFilteredQuery,
} from '../../../common/redux/api/web-api'

const defaultFiltersValue: MeasurementDevicesGetFilteredApiArg = {
    serialNumber: '',
    companyId: '',
    limit: 500,
    name: '',
    status: undefined,
}

export type MeasurementDevicesPageProps = {
    style?: React.CSSProperties
}

export const MeasurementDevicesPage = memo(function MeasurementDevicesPage({
    style,
}: MeasurementDevicesPageProps): React.ReactElement {
    const user = useSelector((state: RootState) => state.user)
    const [filter, setFilter] = useState<MeasurementDevicesGetFilteredApiArg>(defaultFiltersValue)

    const [currentPage, setCurrentPage] = useState(0)
    const filtersContainerRef = useRef<HTMLDivElement | null>(null)

    const handlePageClick = (selected: number) => {
        window.scrollTo(0, filtersContainerRef.current?.offsetTop || 0)
        setCurrentPage(selected)
    }
    const pageClick = () => {
        setCurrentPage(0)
    }

    const handleFilterSubmit = (filters: MeasurementDevicesGetFilteredApiArg) => {
        setFilter(filters)
        pageClick()
    }

    const { currentData: deviceData = [], isLoading: deviceFetching } = useMeasurementDevicesGetFilteredQuery(
        {
            ...filter,
            companyId: user?.selectedCompanyId,
            limit: defaultFiltersValue.limit,
        },
        { refetchOnMountOrArgChange: true }
    )

    const clearDevices = () => {
        setFilter(defaultFiltersValue)
    }

    return (
        <PageLayoutContainer style={style}>
            <MeasurementDeviceSearchListForm
                onSubmit={handleFilterSubmit}
                clearDevice={clearDevices}
                loading={deviceFetching}
            />
            <MeasurementDevicesTableWidget
                data={deviceData ?? []}
                currentPage={currentPage}
                handlePageClick={handlePageClick}
                pageClick={pageClick}
                loading={deviceFetching}
            />
        </PageLayoutContainer>
    )
})
